import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useWaitingLists from '../useWaitingLists';
import DeleteModal from 'components/deleteModalView';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const {
    data,
    columns,
    loading,
    onChangeTableFilter,
    filters,
    onDelete,
    updateInProcess,
    handleDownloadExcel,
  } = useWaitingLists();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('WAITING LIST').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          loading={loading}
          onChange={onChangeTableFilter}
          columns={columns}
          dataSource={data.waiting_lists}
          pagination={data.pagination}
          scroll={{ x: 1000 }}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
